import DOMPurify from 'dompurify';

export const sanitizeHTML = (html: string, DOMPurifyConfig = {}): string => {
  return DOMPurify.sanitize(html, DOMPurifyConfig);
};
